module.exports = function() {
  return new Worker(__webpack_public_path__ + "9664443928f28858087d.worker.js");
};